import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import '../styles/BlogPost.css';
import { Helmet } from 'react-helmet';
import blogPosts from '../data/BlogPostData';
import updateDocumentTitle from '../utils/updateDocumentTitle';

/**
 * Display a single blog post.
 * 
 * @params :slug in URL (useParams).
 * @returns Single Blog Post.
 */

const BlogPost = () => {
  const { slug } = useParams();
  const post = blogPosts.find(post => post.slug === slug) || blogPosts[0];
  
  updateDocumentTitle(post.title);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  return (
    <div className="blog-post-page">
      <Helmet>
        <title>{post.title} | ContractWell Blog</title>
        <meta name="description" content={post.excerpt} />
        <meta property="og:title" content={post.title} />
        <meta property="og:description" content={post.excerpt} />
        <meta property="og:image" content={post.image} />
        <meta property="og:type" content="article" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={post.title} />
        <meta name="twitter:description" content={post.excerpt} />
        <meta name="twitter:image" content={post.image} />
      </Helmet>
      
      <div className="blog-post-header">
        {/* Header is kept minimal */}
      </div>
      
      <div className="blog-post-featured-image">
        <img src={post.image} alt={post.title} />
      </div>
      
      <div className="blog-post-container">
        <h1 className="article-title">{post.title}</h1>
        
        <div className="article-meta">
          <span className="post-category">{post.category}</span>
          <span className="post-date">{post.date}</span>
        </div>
        
        <article className="blog-post-content" dangerouslySetInnerHTML={{ __html: post.content }} />
        
        <div className="blog-post-navigation">
          <Link to="/blog" className="back-to-blog">
            ← Back to all articles
          </Link>
        </div>
      </div>
      
      <div className="related-posts">
        <div className="related-posts-container">
          <h2>Related Articles</h2>
          <div className="related-posts-grid">
            {blogPosts.filter(relatedPost => 
              relatedPost.id !== post.id && 
              (relatedPost.category === post.category || Math.random() > 0.5)
            ).slice(0, 3).map(relatedPost => (
              <div className="related-post-card" key={relatedPost.id}>
                <Link to={`/blog/post/${relatedPost.slug}`} className="related-post-image">
                  <img src={relatedPost.image} alt={relatedPost.title} />
                </Link>
                <div className="related-post-content">
                  <div className="post-meta">
                    <span className="post-category">{relatedPost.category}</span>
                  </div>
                  <h3>
                    <Link to={`/blog/post/${relatedPost.slug}`}>{relatedPost.title}</Link>
                  </h3>
                  <div className="post-date">{relatedPost.date}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogPost; 